<div class="modal-header">
    <h4 class="modal-title">
        <i data-feather="plus"></i> Yeni Ürün Ekle
    </h4>
</div>
<div class="modal-body" *blockUI="'section-blocks'">
    <form [formGroup]="productForm" (ngSubmit)="onSubmit()" class="mt-2">
        <ul ngbNav #nav="ngbNav" class="nav-tabs">
            <li ngbNavItem>
                <a ngbNavLink>Ürün / Hizmet</a>
                <ng-template ngbNavContent>
                    <div class="row">
                        <!-- Ürün Tipi (Başa Alındı) -->
                        <div class="col-6">
                            <label>Ürün Tipi</label>
                            <div class="form-check-group">
                                <div class="d-flex">
                                    <div class="custom-control custom-radio mr-3">
                                        <input type="radio" id="productTypeProduct" formControlName="productType"
                                            class="custom-control-input" [value]="true"
                                            (change)="onProductTypeChange(true)" />
                                        <label class="custom-control-label" for="productTypeProduct">Ürün</label>
                                    </div>
                                    <div class="custom-control custom-radio">
                                        <input type="radio" id="productTypeService" formControlName="productType"
                                            class="custom-control-input" [value]="false"
                                            (change)="onProductTypeChange(false)" />
                                        <label class="custom-control-label" for="productTypeService">Hizmet</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Ürün Adı (Yanına Alındı) -->
                        <div class="col-6">
                            <div class="form-group mb-2">
                                <label for="title">Ürün Adı</label>
                                <input type="text" formControlName="title" class="form-control"
                                    placeholder="Ürün adı" />
                            </div>
                        </div>

                        <!-- Eğer Ürün Seçiliyse Görünecek Alanlar -->
                        <ng-container *ngIf="isProduct">
                            <div class="col-md-6 col-12">
                                <div class="form-group mb-2">
                                    <label for="title">Tip</label>
                                    <ng-select [items]="unitTypes" formControlName="unitTypeId" placeholder="Tip"
                                        bindValue="id" bindLabel="unitTypeName"></ng-select>
                                </div>
                            </div>

                            <div class="col-md-6 col-12">
                                <div class="form-group mb-2">
                                    <label for="type">Alış Vergi</label>
                                    <ng-select [items]="taxes" formControlName="purchaseSaleTaxId"
                                        placeholder="Alış vergisi" bindValue="id" bindLabel="taxRate"></ng-select>
                                </div>
                            </div>

                            <div class="col-md-6 col-12">
                                <div class="form-group mb-2">
                                    <label for="title">Alış Fiyat</label>
                                    <input type="number" formControlName="purchasePrice" class="form-control"
                                        placeholder="Alış fiyatı" />
                                </div>
                            </div>
                        </ng-container>

                        <!-- Ortak Alanlar -->
                        <div class="col-md-6 col-12">
                            <div class="form-group mb-2">
                                <label for="type">Satış Vergi</label>
                                <ng-select [items]="taxes" formControlName="saleTaxId" placeholder="Satış vergisi"
                                    bindValue="id" bindLabel="taxRate"></ng-select>
                            </div>
                        </div>

                        <div class="col-md-6 col-12">
                            <div class="form-group mb-2">
                                <label for="title">Satış Fiyat</label>
                                <input type="number" formControlName="salePrice" class="form-control"
                                    placeholder="Satış fiyatı" />
                            </div>
                        </div>

                        <div class="col-md-6 col-12">
                            <div class="form-group mb-2">
                                <label for="type">Kategori</label>
                                <ng-select [items]="categories" formControlName="categoryId" placeholder="Kategory Seç"
                                    bindValue="id" bindLabel="categoryName"></ng-select>
                            </div>
                        </div>

                        <div class="col-md-6 col-12">
                            <div class="form-group mb-2">
                                <label for="type">Para Birimi</label>
                                <ng-select [items]="currencies" formControlName="currencyId"
                                    placeholder="Para birimi seç" bindValue="id" bindLabel="currencyName"></ng-select>
                            </div>
                        </div>
                        <div class="col-md-6 col-12" *ngIf="!isProduct">
                            <div class="form-group mb-2">
                                <label for="type"></label>
                                <ng-select [items]="kinds" formControlName="kindId" placeholder="Hizmet Türü Seç"
                                    bindValue="id" bindLabel="typeName"></ng-select>
                            </div>
                        </div>
                        <div class="col-md-6 col-12">
                            <div class="form-group mb-2">
                                <label for="title">Barkod</label>
                                <input type="text" formControlName="barcode" class="form-control"
                                    placeholder="Barkod giriniz" />
                            </div>
                        </div>
                        <div class="col-md-6 col-12">
                            <div class="form-group mb-2">
                                <label for="title">Kod</label>
                                <input type="text" formControlName="code" class="form-control"
                                    placeholder="Kod giriniz" />
                            </div>
                        </div>

                    </div>

                </ng-template>
            </li>

            <li ngbNavItem>
                <a ngbNavLink>Varyantlar</a>
                <ng-template ngbNavContent>
                    <div id="varyant" class="col-xl-12">
                        <div class="form-group">
                            <label class="form-label" for="variantSelect">Varyant Seç</label>
                            <ng-select [items]="varyants" bindLabel="name" [multiple]="true"
                                formControlName="selectedVariantItems" placeholder="Varyant Seçiniz"
                                (change)="onVariantChange()">
                                <ng-template ng-header-tmp>
                                    <button type="button"
                                        class="add-new-customer btn btn-flat-success cursor-pointer rounded-0 text-left p-50 w-100"
                                        (click)="showCreateVariant()">
                                        <i data-feather="plus"></i>
                                        <span class="align-middle ml-25">Yeni Varyant Ekle</span>
                                    </button>
                                </ng-template>
                                <ng-template ng-option-tmp let-item="item">
                                    {{ item.name }} <span *ngIf="item.secondName">- {{ item.secondName }}</span>
                                </ng-template>
                            </ng-select>

                        </div>

                        <section id="draggable-cards">
                            <div cdkDropList (cdkDropListDropped)="dropVariant($event)" class="row mt-1"
                                [cdkDropListData]="selectedVaryants.controls">

                                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 mb-2"
                                    *ngFor="let variant of selectedVaryants.controls; let i = index"
                                    [formGroup]="variant" cdkDrag>

                                    <div class="card text-center h-100">
                                        <div
                                            class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                                            <span>{{ variant.get('name')?.value }}</span>
                                            <input type="checkbox" formControlName="isRequired" title="Zorunlu mu?">
                                        </div>

                                        <div class="card-body p-1">
                                            <!-- Option Tipi -->
                                            <div *ngIf="variant.get('variantType')?.value === 1" cdkDropList
                                                (cdkDropListDropped)="dropOption(i, $event)">
                                                <div class="d-flex justify-content-between align-items-center mb-1">
                                                    <label class="mb-0">Seçenekler</label>
                                                    <button type="button" class="btn btn-outline-danger btn-sm"
                                                        (click)="confirmClearOptions(i)">
                                                        <i data-feather="x"></i>
                                                    </button>
                                                </div>
                                                <div style="max-height: 150px; overflow-y: auto; padding-right: 5px;">
                                                    <div cdkDropList [cdkDropListData]="getOptions(i)?.controls"
                                                        (cdkDropListDropped)="dropOption(i, $event)">
                                                        <div *ngFor="let option of getOptions(i)?.controls; let j = index"
                                                            [formGroup]="option" cdkDrag class="d-flex mb-1">
                                                            <input type="text" class="form-control mr-1"
                                                                formControlName="name" placeholder="Seçenek adı">
                                                            <button type="button" class="btn btn-flat-danger btn-sm"
                                                                (click)="removeOption(i, j)">
                                                                <i data-feather="x" class="text-white"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="d-flex justify-content-start mt-1">
                                                    <button type="button" class="btn btn-sm btn-success mt-1"
                                                        (click)="addOption(i)">
                                                        <i data-feather="plus"></i>
                                                    </button>
                                                </div>
                                            </div>

                                            <!-- Doğru/Yanlış Tipi -->
                                            <div *ngIf="variant.get('variantType')?.value === 2" class="mt-1">
                                                <label>Doğru / Yanlış</label>
                                                <input type="text" class="form-control mb-1" formControlName="trueLabel"
                                                    placeholder="Doğru">
                                                <input type="text" class="form-control" formControlName="falseLabel"
                                                    placeholder="Yanlış">
                                            </div>

                                            <!-- Metin Tipi -->
                                            <div *ngIf="variant.get('variantType')?.value === 3" class="mt-1">
                                                <small>Bu varyant metin tipidir, ek input gerekli değil.</small>
                                            </div>
                                        </div>

                                        <div class="card-footer d-flex justify-content-between align-items-center">
                                            <small>Sıra: {{ variant.get('displayOrder')?.value }}</small>
                                            <i data-feather="move" style="cursor: grab;"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </ng-template>
            </li>
        </ul>
        <div [ngbNavOutlet]="nav" class="mt-2"></div>


        <div class="ml-1 d-flex justify-content-end">
            <button type="submit" class="btn btn-success mr-1" rippleEffect
                [disabled]="productForm.invalid">Kaydet</button>
            <button type="reset" class="btn btn-outline-secondary" rippleEffect (click)="closeModal()">İptal</button>
        </div>
    </form>
</div>